import { render, staticRenderFns } from "./DropImage.vue?vue&type=template&id=19d378b2&scoped=true&"
import script from "./DropImage.vue?vue&type=script&lang=js&"
export * from "./DropImage.vue?vue&type=script&lang=js&"
import style0 from "./DropImage.vue?vue&type=style&index=0&id=19d378b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d378b2",
  null
  
)

export default component.exports